export default "__VITE_ASSET__Bs5c5GID__"